{
  "id": "campaign-005",
  "name": "Sunny Lawn",
  "seed": "campaign:5",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........",
    "..**....",
    "........",
    "........",
    "........",
    "...#....",
    ".....#..",
    ".......S"
  ],
  "critters": [],
  "pickups": [
    {
      "kind": "coin",
      "x": 7,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 1
    }
  ],
  "generatorVersion": 3,
  "level": 5,
  "biome": "backyard",
  "par": {
    "reel": 1920,
    "push": 1742,
    "selfPropelled": 1608,
    "tractor": 1600,
    "zeroTurn": 1088,
    "fairway": 638
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 2,
      "selfPropelled": 2,
      "tractor": 20,
      "zeroTurn": 0,
      "fairway": 3
    }
  }
}
